<crm-association-form-field
  [useAssociationFormFields]="true"
  [associationFormFields]="filteredAssociationFormFields()"
  [options]="(options$ | async) ?? []"
  [placeholder]="'ASSOCIATIONS.FORM_FIELD.PLACEHOLDER' | translate"
  [currentSearchTermObjectType]="objectType()"
  [currentSearchTermObjectSubtype]="objectSubtype()"
  [isMobile]="isMobile()"
  (update)="handleUpdate($event)"
  (remove)="handleRemove($event)"
  (searchTermChange)="updateSearchTerm($event)"
  (objectType)="updateObjectType($event)"
></crm-association-form-field>
